//  Name: item-certificate
import { mapGetters } from 'vuex'
import { BLOG_URL, BASE_URL, API } from '@/config'

export default {
  props: [
    'certificate'
  ],
  computed: {
    ...mapGetters([
      'user'
    ]),
    linkDocument () {
      // return BASE_URL + '/courses/certificate/' + this.certificate.validate + '/'
      return `https://pisci-bucket.us-nyc1.upcloudobjects.com/student/${this.certificate.validate}.pdf`
    },
    linkArchive () {
      return ((String(this.certificate.archive).startsWith('https://')) ? '' : `${BASE_URL}/`) + this.certificate.archive
    },
    shareLinkedin () {
      let title = 'Nueva capacitación profesional'
      let description = 'He terminado satisfactoriamente una nueva capacitación "' + this.certificate.course +
      '" con Equipo de Profesionales de Piscicultura Global'
      let link = [
        'https://www.linkedin.com/shareArticle?mini=true',
        'url=' + BLOG_URL,
        'title=' + title,
        'summary=' + description,
        'source=' + this.linkDocument
      ]
      return encodeURI(link.join('&'))
    },
    shareFacebook () {
      let here = 'http://localhost:8080/#/me/certificate'
      let doc = 'https://miriadax.net/files/10132/badge/749dd69d-26f3-46d9-86fe-1a52b080dcc9.pdf'
      let link = [
        'https://facebook.com/dialog/share?app_id=' + API.facebook,
        'display=popup',
        'href=' + doc,
        'redirect_uri=' + here
      ]

      return encodeURI(link.join('&'))
    }
  },
  methods: {
    disabledButton () {
      alert('Por favor complete su perfil para poder acceder a esta opción')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/item-certificate/script.js